



































































































import { encrypt } from '@/utils/common';

document.title = '新商家入驻专属通道';
import { Component, Vue } from 'vue-property-decorator';
import registerApi from '@/api/register';
import { Toast, Picker } from 'vant';
import { regExpObj } from '@/utils/regexp';
interface BusinessData {
  businessType: string;      // 主营租赁类目/商品
  businessDesc: string; // 业务现状
  otherPlatform: string; // 已经入驻的平台
  // companyName: string;   // 公司名称
  contactName: string;       // 联系人
  mobilePhone: string;        // 手机号码
  // email: string;        // 邮箱
  // inviteCode: string;        // 邀请码
  // inviteName: string;        // 邀请人
}
@Component({
  name: 'BusinessForm',
  components: {
    [Picker.name]: Picker,
  },
})
export default class BusinessForm extends Vue {
  pickerShow = false;
  pickerDataType = ''
  pickerChoiceData: string[] = [];

  businessTypeChoiceData = [
    "全新手机",
    "二手手机",
    "平板电脑",
    "相机无人机",
    "其他",
  ];

  businessDescChoiceData = [
    "500w以下",
    "500w-1000w",
    "1000w-2000w",
    "2000w-5000w",
    "5000w以上",
  ]

  private formData: BusinessData = {
    // "companyName": "",
    "contactName": "",
    "mobilePhone": "",
    // "email": "",
    "businessType": "",
    "businessDesc": "",
    "otherPlatform": "",
    // "inviteCode": "",
    // "inviteName": "",
  };

  // 表单验证
  private validateForm(): boolean {
    console.log(1111111111111, this.formData, regExpObj.telephone.test(this.formData.mobilePhone));


    if (!this.formData.contactName) {
      this.$toast.fail('请输入联系人');
      return false;
    }
    if (!regExpObj.telephone.test(this.formData.mobilePhone)) {
      this.$toast.fail('请输入正确的手机号码');
      return false;
    }
    if (!this.formData.businessType) {
      this.$toast.fail('请输入主营类目/商品');
      return false;
    }
    if (!this.formData.businessDesc) {
      this.$toast.fail('请描述业务现状');
      return false;
    }
    if (!this.formData.otherPlatform) {
      this.$toast.fail('请输入入驻过的平台');
      return false;
    }
    /*if (!this.formData.companyName) {
      this.$toast.fail('请输入公司名称');
      return false;
    }*/
    // if (!this.formData.inviteCode) {
    //   this.$toast.fail('请输入邀请码');
    //   return false;
    // }
    /*if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.formData.email)) {
      this.$toast.fail('请输入正确的邮箱地址');
      return false;
    }*/
    return true;
  }

  // 提交表单
  private handleSubmit() {
    if (!this.validateForm()) return;

    // TODO: 调用提交接口
    console.log('提交的表单数据：', this.formData);

    const data = JSON.parse(JSON.stringify(this.formData));

    data.contactNameEncrypt = encrypt(data.contactName);
    data.mobilePhoneEncrypt = encrypt(data.mobilePhone);
    delete data.contactName;
    delete data.mobilePhone;

    this.$http({
      url: registerApi.saveMerchantRegister.url,
      method: registerApi.saveMerchantRegister.method,
      params: data,
    }).then(() => {
      this.$toast.success('提交成功');
      this.formData = {
        // "companyName": "",
        "contactName": "",
        "mobilePhone": "",
        // "email": "",
        "businessType": "",
        "businessDesc": "",
        "otherPlatform": "",
        // "inviteCode": "",
        // "inviteName": "",
      };
    });
  }

  showPicker(dataType: string) {
    if (dataType === 'businessType') {
      this.pickerDataType = 'businessType'
      this.pickerChoiceData = this.businessTypeChoiceData
    }
    if (dataType === 'businessDesc') {
      this.pickerDataType = 'businessDesc'
      this.pickerChoiceData = this.businessDescChoiceData
    }
    this.pickerShow = true
  }

  onCancel() {
    this.pickerShow = false
    console.log("取消")
  }
  onconfirm(event: any) {
    console.log(event, 222)
  }

  // 选择下拉选项数据
  private choiceData(value: any) {
    if (this.pickerDataType === 'businessType') {
      this.formData.businessType = value
    }
    if (this.pickerDataType === 'businessDesc') {
      this.formData.businessDesc = value
    }
    this.pickerDataType = ''
    this.pickerShow = false
  }
}
